import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ResolvableServiceForm_ResolvableService_Create_Mutation = graphql(`
  mutation ResolvableServiceForm_ResolvableService_Create(
    $resolvableService: ResolvableServiceInput!
    $versionData: VersionDataInput
  ) {
    createResolvableService(
      doc: $resolvableService
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export type ResolvableServiceInput = VariablesOf<
  typeof ResolvableServiceForm_ResolvableService_Create_Mutation
>['resolvableService'];

export type ResolvableServiceForm_ResolvableService_Create_Result = ResultOf<
  typeof ResolvableServiceForm_ResolvableService_Create_Mutation
>;

export const useCreateResolvableServiceMutation = () =>
  useGraphQLMutation(ResolvableServiceForm_ResolvableService_Create_Mutation);
